import { getAddressInfo } from './getAddressInfo.js';
export const isAddress = (address, network) => {
    try {
        const addressInfo = getAddressInfo(address);
        if (network) {
            return network === addressInfo.network;
        }
        return true;
    }
    catch (_error) {
        return false;
    }
};
//# sourceMappingURL=isAddress.js.map